import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.entity-types';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungEntityTypesEffects {

    EntityTypes$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_ENTITY_TYPES),
        mergeMap((x: ac.GetEntityTypesAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getEntityTypes().pipe(
                map((result: any) => {
                    return new ac.GetEntityTypesErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetEntityTypesFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.BenutzerverwaltungTemplatesService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.BenutzerverwaltungTemplatesService {
        if (this.service === null) {
            this.service = this.injector.get(api.BenutzerverwaltungTemplatesService);
        }
        return this.service;
    }
}
